import Log from '@deephaven/log';
var log = Log.module('redux-logger');
var logger = store => next => action => {
  log.debug('dispatching', action);
  var result = next(action);
  log.debug('next state', store.getState());
  return result;
};
export default logger;
//# sourceMappingURL=logger.js.map